import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { PhoneIncoming } from "lucide-react";
import React from "react";

const InboundDirectCallsWidget: React.FC<{ data: { value: number; comparisonPercentage?: number }; icon?: React.ReactNode; loading?: boolean; error?: string }> = ({ data, loading }) => {
  return (
    <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#3C5C73] p-3">
      <div className="flex flex-row items-center justify-between">
        <div className="text-[14px] font-[600] text-teamscx-primary dark:text-white truncate">Total Inbound Direct Calls</div>
        <TooltipProvider>
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <span className="cursor-pointer">
                <PhoneIncoming className="h-4 w-4 text-primary dark:text-white" />
              </span>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="max-w-xs text-xs">
                The total number of incoming calls that have entered directly to the agent’s line within the given time.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div>
        <WidgetMetricDisplay
          value={data.value}
          comparisonPercentage={data.comparisonPercentage}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default InboundDirectCallsWidget;